import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Vision from "../../components/Vision/Vision";
import Partnership from "../../components/Partnership/Partnership";
import Values from "../../components/Values/Values";
import Presentation from "../../components/About/Presentation";
import CmsRenderer from "../../components/CmsRenderer/CmsRenderer";
import cmsClient from "../../lib/cmsClient";
import { useScrollReveal } from "../../hooks/useScrollReveal";
import "./About.css";

const ABOUT_STATS = [
  { value: "15+", label: "Clients accompagnes" },
  { value: "7j",  label: "Delai moyen de livraison" },
  { value: "3",   label: "Ans d'experience" },
  { value: "100%", label: "Projets livres a temps" },
];

const TEAM = [
  {
    initial: "H",
    name: "Hassane Soumahoro",
    role: "Fondateur & Developpeur Fullstack",
    desc: "React · Node.js · React Native · MongoDB. Passionne par les solutions digitales adaptees au marche ivoirien.",
    linkedin: "https://www.linkedin.com/in/hassane-soumahoro",
  },
];

export default function About() {
  useScrollReveal();
  const [cmsPage, setCmsPage] = React.useState({ blocks: [], theme: {} });

  React.useEffect(() => {
    (async () => {
      try {
        const j = await cmsClient.getPage('about');
        if (j?.success) setCmsPage(j.data || { blocks: [], theme: {} });
      } catch (_e) {}
    })();
  }, []);

  const hasBlocks = (cmsPage.blocks || []).length > 0;

  return (
    <>
      <Helmet>
        <title>Qui sommes-nous — NEXUS SOLUTIONS</title>
        <meta name="description" content="NEXUS SOLUTIONS est une agence digitale basee a Abidjan. Decouvrez notre vision, nos valeurs et notre equipe." />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "name": "À propos de NEXUS SOLUTIONS",
          "url": "https://nxs-solutions.com/about",
          "mainEntity": {
            "@type": "Organization",
            "name": "NEXUS SOLUTIONS",
            "foundingDate": "2023",
            "foundingLocation": "Abidjan, Côte d'Ivoire",
            "description": "Agence digitale fondée à Abidjan, spécialisée en développement web, mobile et e-commerce pour les PME africaines.",
            "employee": [
              { "@type": "Person", "name": "Hassane Soumahoro", "jobTitle": "Fondateur & Développeur Fullstack" }
            ]
          }
        })}</script>
      </Helmet>

      {hasBlocks ? (
        <CmsRenderer blocks={cmsPage.blocks} />
      ) : (
        <>
          {/* Hero */}
          <div className="about-hero">
            <div className="about-hero__label">Notre histoire</div>
            <h1 className="about-hero__title">
              Une agence digitale<br />
              <span>nee a Abidjan</span>
            </h1>
            <p className="about-hero__sub">
              On construit des solutions pour les entrepreneurs ivoiriens — pas des templates coupe-colles d'un modele etranger.
            </p>
          </div>

          {/* Stats strip */}
          <div className="about-stats">
            {ABOUT_STATS.map((s, i) => (
              <div className="about-stats__item" key={s.label} data-reveal="" data-delay={i * 80}>
                <span className="about-stats__value">{s.value}</span>
                <span className="about-stats__label">{s.label}</span>
              </div>
            ))}
          </div>

          <Presentation />
          <Vision />
          <Partnership />
          <Values />

          {/* Team section */}
          <section className="about-team">
            <div className="about-team__inner">
              <h2 className="about-team__title" data-reveal="">L'equipe</h2>
              <div className="about-team__grid">
                {TEAM.map((m, i) => (
                  <div className="about-team__card" key={m.name} data-reveal="" data-delay={i * 100}>
                    <div className="about-team__avatar">{m.initial}</div>
                    <div className="about-team__name">{m.name}</div>
                    <div className="about-team__role">{m.role}</div>
                    <p className="about-team__desc">{m.desc}</p>
                    {m.linkedin && (
                      <a href={m.linkedin} target="_blank" rel="noreferrer" className="about-team__linkedin">
                        LinkedIn →
                      </a>
                    )}
                  </div>
                ))}
                <div className="about-team__card about-team__card--recruit" data-reveal="" data-delay="100">
                  <div className="about-team__recruit-icon">🚀</div>
                  <div className="about-team__name">On recrute</div>
                  <div className="about-team__role">Developpeur · Designer · Commercial</div>
                  <p className="about-team__desc">
                    Rejoignez l'equipe et travaillez sur des projets concrets pour les PME ivoiriennes.
                  </p>
                  <Link to="/careers" className="about-team__cta">Voir les offres</Link>
                </div>
              </div>
            </div>
          </section>

          {/* Final CTA */}
          <section className="about-cta">
            <h2 className="about-cta__title">Pret a lancer votre projet ?</h2>
            <p className="about-cta__sub">
              La premiere consultation est gratuite. Parlez-nous de votre idee.
            </p>
            <Link to="/devis" className="about-cta__btn">Demarrer un projet</Link>
          </section>
        </>
      )}
    </>
  );
}
